import { pt as langPt } from "assets/locales/pt-br";
import { lang } from "i18nLang";

const fields = [
  "codeWBS",
  "description",
  "quantity",
  "unit",
  "unitCost",
  "total",
  "percentage",
];

const notFound = "not found";
const emptyWorksheet = "Empty worksheet";
const originalMessages = [...Object.keys(langPt.importation.errors)];

class ContractImportException extends Error {
  public readonly messageTranslated: string = "";

  constructor(message) {
    super(message);
    this.name = "ContractImportException";

    const error = this.splitErrorMessage(message) || "";
    this.messageTranslated = this.isJsonString(error)
      ? this.translateDataToMessage(error)
      : this.translateText(error);
  }

  splitErrorMessage(message: string): string | undefined {
    const messageSplitted = message.split("Error: ");
    return messageSplitted && messageSplitted.length
      ? messageSplitted.pop()
      : message;
  }

  translateText(message: string): string {
    let newMessage = "";
    const type = originalMessages.find((key) => message.indexOf(key) !== -1);

    if (type) {
      newMessage = message
        .replace(type, lang(`importation.errors.${type}`))
        .replace(notFound, lang(`importation.notFound`))
        .replace(emptyWorksheet, lang(`importation.emptyWorksheet`));

      fields.forEach((field) => {
        newMessage.replace(field, lang(`fields.${field}`));
      });
    }

    return newMessage;
  }

  isJsonString(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  translateDataToMessage(messageData: string): string {
    let newMessage = "";
    let data = JSON.parse(messageData);
    if (data.length > 0) {
      data.forEach((data) => {
        let message = this.translateText(data.message);
        newMessage += message + "\n";
      });
    }
    return newMessage;
  }
}

export default ContractImportException;
